import React from "react";
import { User } from "../../slices/usersSlice";
import UserManagementActionMenu from "../UserManagementActionMenu/UserManagementActionMenu";
import { Column } from "@/components/Datatable/types";
import GravatarAvatar from "@/components/GravatarAvatar/GravatarAvatar";
import { Badge } from "@/components/Badge/Badge";

interface CreateUsersColumnsProps {
  handleEdit: (uuid: string) => void;
  handleDeactivateUser: (user: User) => void;
  handleReactivateUser: (user: User) => void;
}

export function createUsersColumns({
  handleEdit,
  handleDeactivateUser,
  handleReactivateUser,
}: CreateUsersColumnsProps): Column<User>[] {
  return [
    {
      header: "Name",
      accessorKey: "firstName",
      enableSorting: true,
      cell: ({ row }) => {
        const user = row.original;
        return (
          <div className="flex items-center gap-2.5">
            <GravatarAvatar
              email={user.email}
              firstName={user.firstName}
              lastName={user.lastName}
              size="sm"
            />
            <span>
              {user.firstName} {user.lastName}
            </span>
          </div>
        );
      },
    },
    {
      header: "Email",
      accessorKey: "email",
      enableSorting: true,
    },
    {
      header: "Role",
      accessorKey: "roleLabel",
      enableSorting: true,
      cell: ({ row }) => {
        const roleLabel = row.original.roleLabel;
        return roleLabel || <span className="text-muted-foreground">—</span>;
      },
    },
    {
      id: "employeeStatus",
      header: "Employee Status",
      cell: ({ row }) =>
        row.original.isActive ? (
          <Badge variant="success">Active</Badge>
        ) : (
          <Badge variant="grey">Inactive</Badge>
        ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const userItem = row.original;

        return (
          <UserManagementActionMenu
            employeeUuid={userItem.employeeUuid || ""}
            isActive={userItem.isActive}
            onDeactivateUser={() => handleDeactivateUser(userItem)}
            onEdit={handleEdit}
            onReactivateUser={() => handleReactivateUser(userItem)}
          />
        );
      },
    },
  ];
}
